(() => {
  if(window.AplovioAccount)return;
  window.AplovioAccount=true;
  const place=dialog=>{
    const header=dialog.closest('aplovio-header'),trigger=header?.querySelector('[data-account-open]');
    if(!trigger)return;
    const rect=trigger.getBoundingClientRect(),surface=header.querySelector('.ap-header__surface').getBoundingClientRect();
    dialog.style.setProperty('--ap-account-top',`${Math.max(8,Math.min(surface.bottom,innerHeight-120))}px`);
    dialog.style.setProperty('--ap-account-edge',`${Math.max(16,innerWidth-rect.right-24)}px`);
  };
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-account-open]');
    if(!trigger||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const layer=document.getElementById(trigger.getAttribute('aria-controls'));
    if(!layer?.open)return;
    place(layer.dialog);event.preventDefault();layer.open(trigger);
  });
  for(const state of ['open','close'])document.addEventListener(`aplovio:layer-${state}`,event=>{
    if(event.target.matches('.ap-account-layer'))event.target.closest('aplovio-header')?.querySelector('[data-account-open]')?.setAttribute('aria-expanded',String(state==='open'));
  });
  addEventListener('resize',()=>document.querySelectorAll('.ap-account-layer[open]').forEach(place),{passive:true});
})();
